export default "__VITE_ASSET__7lNj453W__"